<template>
  <v-card id="allergy-list" class="mb-2">
    <v-card-title>
      <v-btn elevation="1" class="mr-3" fab small @click="TOGGLE_CLOSED_BLOCK('allergy')" color="white">
        <v-icon>
          mdi-dots-vertical
        </v-icon>
      </v-btn>
      <h2>Аллергии</h2>

      <v-spacer></v-spacer>

      <!--      <v-text-field-->
      <!--        v-model="search"-->
      <!--        @input="apiSearch"-->
      <!--        append-icon="mdi-magnify"-->
      <!--        label="Поиск по аллергиям"-->
      <!--        single-line-->
      <!--        hide-details-->
      <!--      ></v-text-field>-->
      <modal depressed icon="add" title="Добавить аллергию" name="Аллергию" component="add-allergy"></modal>
    </v-card-title>

    <v-data-table
      v-if="isShow"
      :headers="headers"
      :items="items"
      :loading="loading"
      :options.sync="options"
      :server-items-length="meta.total"
    >
      <template v-slot:top>
        <v-container fluid>
          <v-row no-gutters>
            <v-col cols="12" sm="3" class="mr-3">
              <date-range-picker v-model="filter.date" @input="load" dense />
            </v-col>

            <v-col cols="12" sm="3" class="mr-3">
              <v-select
                class="ma-0 pa-0"
                dense
                hide-details
                label="Тип аллергии"
                item-text="name"
                item-value="id"
                :items="allergyTypes"
                v-model="filter.type"
                @change="
                  onSelectAllergyType();
                  load();
                "
              ></v-select>
            </v-col>

            <v-col cols="12" sm="3" class="mr-3">
              <v-select
                class="ma-0 pa-0"
                dense
                hide-details
                label="Аллерген"
                item-text="name"
                item-value="id"
                :items="allergyTypeAllergens"
                v-model="filter.allergen"
                @change="load"
              ></v-select>
            </v-col>
          </v-row>
        </v-container>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-icon class="mr-2" @click="editItem(item)">
          mdi-pencil
        </v-icon>
        <v-icon @click="deleteItem(item)">
          mdi-delete
        </v-icon>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import Modal from "@/components/Modal";
import throttle from "lodash/throttle";
import { QueryHelper } from "@/services/query-helper";
import { mapState, mapMutations } from "vuex";
import { CustomerService } from "@/services/api/customer.service";
import AddAllergy from "@/components/modals/AddAllergy";
import DateRangePicker from "@/components/forms/DateRangePicker";
import { AllergyService } from "@/services/api/allergy.service";

export default {
  name: "AllergyList",
  components: { DateRangePicker, Modal },
  data: () => ({
    loading: true,
    options: {},
    search: "",
    filter: {
      type: "",
      allergen: "",
      date: [],
    },
    allergyTypes: [],
    allergyTypeAllergens: [],
    headers: [
      { text: "Дата обнаружения", value: "date_start", align: "start", sortable: true },
      { text: "Тип аллергии", value: "type", align: "start", sortable: false },
      { text: "Аллерген", value: "allergens", align: "start", sortable: false },
      { text: "Где проявляется", value: "areas", align: "start", sortable: false },
      { text: "Реакция", value: "reactions", align: "start", sortable: false },
      { text: "Степень", value: "degree", align: "start", sortable: false },
      { value: "actions", sortable: false },
    ],
  }),

  computed: {
    ...mapState("ikp", ["closedBlocks"]),

    isShow() {
      return !this.closedBlocks.includes("allergy");
    },
    customerId() {
      return this.$store.state.customer.id;
    },

    ...mapState("allergies", ["items", "meta"]),
  },

  watch: {
    options: {
      handler() {
        this.load();
      },
      deep: true,
    },
  },

  async created() {
    this.allergyTypes = await AllergyService.getTypes();
  },

  methods: {
    ...mapMutations("ikp", ["TOGGLE_CLOSED_BLOCK"]),
    async load() {
      this.loading = true;
      const params = {
        search: this.search,
        ...QueryHelper.tableSorting(this.options),
        ...QueryHelper.filter(this.filter),
        ...QueryHelper.pagination(this.options, this.meta.total),
      };

      try {
        const response = await this.$http.get(`v1/customers/${this.customerId}/allergies`, { params }).then(r => r.data);
        this.$store.commit("allergies/SET_ITEMS", response.data);
        this.$store.commit("allergies/SET_META_TOTAL", response.meta.total);
      } catch (e) {
        // TODO: Обработать ошибку
        console.error(e);

        this.$store.commit("allergies/SET_ITEMS", []);
        this.$store.commit("allergies/SET_META_TOTAL", 0);
        this.meta.total = 0;
      }

      this.loading = false;
    },

    apiSearch: throttle(async function apiSearchHandler() {
      await this.load();
    }, 1000),

    /**
     * Загружает список алергенов для выбраного типа.
     * После изменения типа, сбрасывает старое значения аллергена
     */
    async onSelectAllergyType() {
      this.filter.allergen = "";
      this.allergyTypeAllergens = await AllergyService.getAllergens(this.filter.type);
    },

    /**
     * @param {DiseasesItem} item
     * @return {Promise<void>}
     */
    async editItem(item) {
      const response = await CustomerService.getAllergy(this.customerId, item.id);
      this.$dialog.show(AddAllergy, { model: response, width: 600, persistent: true });
    },

    async deleteItem(item) {
      const title = item.title ? `"${item.title}"` : "";
      const result = await this.$dialog.confirm({
        title: "Удаление аллергии",
        text: `Вы подтверждаете удаление аллергии ${title}`,
      });

      if (result) {
        this.loading = true;
        await this.$store.dispatch("allergies/removeItem", item);

        if (this.items.length === 0) {
          await this.load();
        }

        this.loading = false;
      }
    },
  },
};
</script>

<style scoped></style>
